import { render, staticRenderFns } from "./VDesigningPlansEditor.vue?vue&type=template&id=65d58cfb&"
import script from "./VDesigningPlansEditor.vue?vue&type=script&lang=ts&"
export * from "./VDesigningPlansEditor.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningPlansEditor.vue?vue&type=style&index=0&id=65d58cfb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports